import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import CoreRouter from "./containers/CoreRouter";
import { UserSessionProvider } from "./contexts/UserSessionContext";
import AppCrashFallback from "./components/AppCrashFallback";

import * as Sentry from "@sentry/react";

// DSN is overridable per environment; the literal is the existing app.aicosts.ai
// project so a build without the env var keeps reporting where it always did.
const dsn =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://1e3534072617f7ea8de530b7635ee823@o382392.ingest.us.sentry.io/4509235756793856";
const isProd = process.env.NODE_ENV === "production";

Sentry.init({
  dsn,
  enabled: Boolean(dsn),
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  release: process.env.REACT_APP_SENTRY_RELEASE,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  tracesSampleRate: Number(
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? (isProd ? "0.1" : "1.0")
  ),

  // Only record a replay when something actually broke, which keeps the
  // replay quota for sessions worth watching.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,

  sendDefaultPii: false,

  // Browser extensions, cancelled navigations and ad-blocker noise otherwise
  // drown out real bugs.
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    "Non-Error promise rejection captured",
    "AbortError",
    "NetworkError when attempting to fetch resource",
  ],
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
  ],
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* Catches render crashes that would otherwise blank the dashboard
        with no report. */}
    <Sentry.ErrorBoundary fallback={<AppCrashFallback />}>
      <UserSessionProvider>
        <CoreRouter />
      </UserSessionProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
